/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 */

import 'zone.js'; // Included by default with Angular CLI.
import 'regenerator-runtime/runtime'; // Required for gcs-browser-upload library